
import React from 'react';

interface StarIconProps extends React.SVGProps<SVGSVGElement> {}

const OrangeDoubleExclamationIcon: React.FC<StarIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    {...props}
  >
    <path 
      fillRule="evenodd" 
      d="M10.275 2.24a.75.75 0 0 0-1.03-.736A12 12 0 0 0 1.5 11.25a.75.75 0 0 0 1.5 0A10.5 10.5 0 0 1 9.53 2.251a.75.75 0 0 0 .745-.011Zm1.06-.736a.75.75 0 0 1 1.03.736A10.5 10.5 0 0 1 21 11.25a.75.75 0 0 1-1.5 0A12 12 0 0 0 11.336 1.503a.75.75 0 0 1-.001-.000ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75ZM12 16.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" 
      clipRule="evenodd" 
    />
    <path 
      fillRule="evenodd" 
      d="M15.75 12c0 .802-.295 1.537-.781 2.106A3.739 3.739 0 0 1 12 15a3.739 3.739 0 0 1-2.969-.894.75.75 0 1 0-1.062 1.062A5.238 5.238 0 0 0 12 16.5a5.238 5.238 0 0 0 4.12-2.22c.57-.713.93-1.609.93-2.58A5.25 5.25 0 0 0 12 6.75a5.253 5.253 0 0 0-4.22 2.031.75.75 0 0 0 1.063 1.062A3.75 3.75 0 0 1 12 8.25c2.071 0 3.75 1.679 3.75 3.75Z" 
      clipRule="evenodd" 
    />
  </svg>
);

export default OrangeDoubleExclamationIcon;
